<template>
    <div>
        <div class="flex mb10" style="justify-content: space-between;">
            <div class="flex-width flex items-center">
                <img src="../../../../../public/images/guigeguanli.png" style="width:25px;height:25px" />
                <a-dropdown class="ml5">
                    <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                        {{ select_item.name }} <a-icon type="down" />
                    </a>
                    <a-menu slot="overlay">
                        <a-menu-item>
                            <a href="javascript:;" @click="changeSelectItem(0)">全部物资报废</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a href="javascript:;" @click="changeSelectItem(1)">我发起的物资报废</a>
                        </a-menu-item>
                    </a-menu>
                </a-dropdown>
            </div>
            <!-- <div class="flex items-center">
                <img class="ml15 mr10" src="../../../../../public/images/guigeguanli.png" style="width:25px;height:25px" />
                <div class="ml20 fs14" style="color:grey">物资报废</div>
            </div> -->
            <div class="flex"> 
                <a-input-search size="small" allowClear v-model="search" placeholder="请输入关键字" enter-button  @search="onSearch" @pressEnter="onSearch"/>
                
                <!-- <a-button size="small" class="" style="background-color: #fd6364;color: white;" icon="sync" @click="reset">
                    导出
                </a-button> -->
                <a-button size="small" class="ml10" style="background-color: #fd6364;color: white;" @click="scrapAdd"><a-icon type="plus" />
                    新增
                </a-button>
                <a-icon type="plus" style="color:white" />
            </div>
        </div>
        
        <a-row :gutter="24" type="flex" align="stretch">
            <a-col :span="24" :lg="30" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0,}">
                    <a-table bordered :data-source="scrapData" :columns="scrapColumns" :pagination="false"  class="pd15" size="small">
                        <template slot="status" slot-scope="text, record">
                            <!-- <a-tag v-if="record.status==1" color="blue">审批完成</a-tag>
                            <a-tag v-if="record.status==2" color="red">审批拒绝</a-tag>
                            <a-tag v-else color="white">正在审批</a-tag> -->
                            <span v-if="record.status == 0" style="color:orange;">等待审批</span>
                            <span v-else-if="record.status == 1" style="color:green;">审批通过</span>
                            <span v-else-if="record.status == 2" style="color:#fd6363;">拒绝</span>
                        </template>
                        <template slot="operation" slot-scope="text, record">
                            <a href="javascript:;" @click="checkMaterial(record)">查看</a>
                            <!-- <a-divider type="vertical" />
                            <a-popconfirm
                                v-if="scrapData.length"
                                title="确定删除?"
                                ok-text="确定" cancel-text="取消"
                                @confirm="() => onDeleteScrap(record.id)"
                            >
                                <a href="javascript:;">删除</a>
                            </a-popconfirm> -->
                        </template>
                    </a-table>
                    <div>
                        <a-pagination 
                            class="flex items-center mb10"
                            style="justify-content: flex-end"
                            show-quick-jumper  
                            v-model="page.page" 
                            :total="page.total" 
                            @change="onShowSizeChange" 
                        />
                    </div>
                </a-card>
            </a-col>
        </a-row>
        <a-drawer
            :width="1200"
            :visible="visibleCheckScrap"
            :body-style="{ paddingBottom: '80px' }"
            @close="visibleCheckScrap = false"
        >
            <CardMaterialScrapDetail :scrapDetail="selectRecord" :approvalDetail="approvalDetail" :approvalForm="approval_form" @update-param="updateParam"></CardMaterialScrapDetail>
        </a-drawer>


        <a-drawer
            title="新增物资报废·默认业务类型"
            :width="1200"
            :visible="visibleAddScrap"
            :confirm-loading="confirmLoading"
            :body-style="{ paddingBottom: '80px' }"
            @close="visibleAddScrap = false"
        >
        <!-- <a-modal
            title="新增物资报废·默认业务类型"
            :visible="visibleAddScrap"
            :width="1200"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="visibleAddScrap = false"
            cancelText="取消"
            okText="保存" 
        > -->
            <CardMaterialScrapAdd ref="son" :scrapDetail="scrapDetail"></CardMaterialScrapAdd>
            <div
				:style="{
					position: 'absolute',
					right: 0,
					bottom: 0,
					width: '100%',
					borderTop: '1px solid #e9e9e9',
					padding: '10px 16px',
					background: '#fff',
					textAlign: 'right',
					zIndex: 1,
				}"
			>
				<a-button :style="{ marginRight: '8px' }" @click="visibleAddScrap = false">
					取消
				</a-button>
				<a-button type="danger" @click="handleOk">
					提交
				</a-button>
			</div>
        </a-drawer>
    </div>
</template>
<script>
import CardMaterialScrapAdd from '../../../../components/Cards/CardMaterialScrapAdd.vue';
import CardMaterialScrapDetail from '../../../../components/Cards/CardMaterialScrapDetail.vue';
const KF = 'updatable';
export default {
    components: {
        CardMaterialScrapAdd,
        CardMaterialScrapDetail
    },
    data() {
        return {
            form: this.$form.createForm(this),
            visibleAddScrap: false,
            visibleCheckScrap:false,
            scrapDetail:{event_type:32,data:{project_id:0,project_name:"", inv_id:0, material_name:"",size:"", unit:"", brand:"", count:0, current_count:0, unit_price:"", total_price:"", repair_fee:"", reason:"", note:"", attachment:[]},approval_person:{flow_type:1, persons:[]},send_person:{flow_type:2, persons:[]},person:[]},
            scrapData: [],
            scrapColumns: [
                {
                    title: '序号',
                    dataIndex: 'key',
                    key: 'key',
                },
                {
                    title: '物资名称',
                    dataIndex: 'data.material_name',
                },
                {
                    title: '品牌',
                    dataIndex: 'data.brand',
                },
                {
                    title: '规格型号',
                    dataIndex: 'data.size',
                    ellipsis: true,
                },
                {
                    title: '单位',
                    dataIndex: 'data.unit',
                    key: 'unit',
                },
                {
                    title: '数量',
                    dataIndex: 'data.count',
                    key: 'count',
                },
                {
                    title: '单价',
                    dataIndex: 'data.unit_price',
                    key: 'unit_price',
                },
                {
                    title: '金额',
                    dataIndex: 'data.total_price',
                    key: 'total_price',
                },
                {
                    title: '维修费用',
                    dataIndex: 'data.repair_fee',
                    key: 'repair_fee',
                },
                {
                    title: '报废原因',
                    dataIndex: 'data.reason',
                    key: 'reason',
                },
                {
                    title: '备注',
                    dataIndex: 'data.note',
                },
                {
                    title: '状态',
                    dataIndex: 'data.status',
                    scopedSlots: { customRender: 'status' },
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    key: 'operation',
                    scopedSlots: { customRender: 'operation' },
                }
            ],
            page:{page:1, total:0},
            selectMaterial:{},
            search:"",
            materialsList:[],
            confirmLoading:false,
            selectRecord:{},
            flowdata:[],
            approvalDetail:[],
            select_item:{id:0, name:"全部物资报废"},
            approval_form:{id:null, name:null, confirm_status:0, role:null},   //0未审批 1同意 2拒绝 3不是审批人员


        };
    },
    async created(){
        this.getMaterialScrapApplyRecord()
        this.getProjectFlow()
        // this.cacheEnquiryData = this.enquiryData.map(item => ({ ...item }))
    },
    methods: {
        check() {
            this.form.validateFields(err => {
                if (!err) {
                    console.info('success');
                }
            });
        },
        async getMaterialScrapApplyRecord(){
            let rs = await this.$api.getMaterialScrapApplyRecord(this.search, this.select_item.id, this.page.page - 1, 10);
            // console.log(rs.data)
            if(rs.err == 0){
                let ca = 1
                for(let item of rs.data){
                    item.key = ca
                    item.create_time = item.create_time.replace("T", " ")
                    item.data = JSON.parse(item.data)
                    ca ++
                }
                this.approval_form.id = rs.user_id
                this.approval_form.name = rs.user_name
                this.approval_form.role = rs.role

                this.scrapData = rs.data
                this.page.total = rs.count
            }
        },
        // async onDeleteScrap(key) {
        //     const scrapData = [...this.scrapData];
        //     this.scrapData = scrapData.filter(item => item.key !== key);

        // },
        // 增加物资报废条目
        scrapAdd(){
            this.scrapDetail = {event_type:32,data:{project_id:0,project_name:"", inv_id:0, material_name:"",size:"", unit:"",brand:"", count:0, current_count:0, unit_price:"", total_price:"", repair_fee:"", reason:"", note:"", attachment:[]},approval_person:{flow_type:1, persons:[]},send_person:{flow_type:2, persons:[]},person:[]},
            this.visibleAddScrap = true;
            
        },
        async getApprovalDetail(){
            let rs = await this.$api.getApprovalDetail(this.selectRecord.id)
            if(rs.err == 0 ){
                let ca = 1
                for(let item of rs.data){
                    item.key = ca
                    ca++
                }
                this.approvalDetail = rs.data
                // let check = this.approvalDetail.find(it=>it.uid == this.approval_form.id && it.flow_idx == this.select_stamp.step)
                let check = rs.data.find(it=>it.uid == this.approval_form.id)
                this.approval_form.confirm_status = (check != null)?check.status:3
                // console.log("approvalDetail")
                // console.log(this.approvalDetail)
                // console.log("selectRecord")
                // console.log(this.selectRecord)
            }
            // console.log(this.approvalDetail)

        },
        checkMaterial(record){
            this.selectRecord = record
            this.getApprovalDetail()
            this.visibleCheckScrap = true
        },   
        onClose(){
            this.visibleAddScrap = false;
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        updateMaterialSelect(){
            console.log(this.selectMaterial)
        },
        onSearch(){
            this.page.page = 1
            this.getMaterialScrapApplyRecord()
        },
        checkScrapDetail(){
            if(this.scrapDetail.data.project_id == 0){
                this.$notification['warning']({
                    message: '请选择项目',
                    style: {
                        width: '600px',
                        marginLeft: `${335 - 600}px`,
                    },
                });
                return;
            }
            if(this.scrapDetail.data.inv_id == 0){
                this.$notification['warning']({
                    message: '请选择物资',
                    style: {
                        width: '600px',
                        marginLeft: `${335 - 600}px`,
                    },
                });
                return;
            }
            if(this.scrapDetail.data.unit_price == 0){
                this.$notification['warning']({
                    message: '请输入单价',
                    style: {
                        width: '600px',
                        marginLeft: `${335 - 600}px`,
                    },
                });
                return;
            }
            if(this.scrapDetail.data.count == 0){
                this.$notification['warning']({
                    message: '请输入数量',
                    style: {
                        width: '600px',
                        marginLeft: `${335 - 600}px`,
                    },
                });
                return;
            }
            // if(this.scrapDetail.approval_person.persons.length == 0){
            //     this.$notification['warning']({
            //         message: '请选择审批人',
            //         style: {
            //             width: '600px',
            //             marginLeft: `${335 - 600}px`,
            //         },
            //     });
            //     return false;
            // }
            return true;
            
        },
        goBack(){
            window.history.go(-1)
        },
        async handleOk(e) {

            if(!this.checkScrapDetail()){
                return
            }
    

            let data = [];
            for (let item of this.flowdata) {
                let vo = {
                    flow_type: item.flow_type,
                    persons: []
                }
                if (item.approver_uid != 0) {
                    vo.persons.push(item.approver_uid);
                }
                if (item.persons.length > 0) {
                    for (let p of item.persons) {
                        vo.persons.push(p.user_id);
                    }
                }
                data.push(vo);
            }
            this.scrapDetail.person = data;
            // console.log(this.scrapDetail)

            let rs = await this.$api.goAddMaterialScrap(this.scrapDetail)
            if(rs.err == 0){
                if(rs.err == 0){
                    // this.$message.loading({ content: '正在提交...', KF })
                    this.$message.success('提交成功')
                    this.visibleAddScrap = false
                    this.getMaterialScrapApplyRecord()
                }else{
                    // this.$message.loading({ content: '正在提交...', KF })
                    this.$message.warn('提交失败，请检查后重试或联系管理员')
                }
            }else{
                this.$notification['error']({
                    message: '提交失败，请重试或联系管理员',
                    style: {
                        width: '600px',
                        marginLeft: `${335 - 600}px`,
                    },
                });
            }
        },
        onShowSizeChange() {
            if(this.search.length != 0){
                this.onSearch()
            }else{
                this.getMaterialScrapApplyRecord()
            }
        },
        async getProjectFlow() {
            let rs = await this.$api.getCompanyProjectFlow(32, {departments: 14, projects: this.scrapDetail.data.project_id});
            // console.log(rs.data)
            if (rs.err == 0) {
                for (let item of rs.data.flowdata) {
                    if (item.persons == null) {
                        item.persons = [];
                    }
                }
                this.flowdata = rs.data.flowdata;
            }
        },
        changeSelectItem(key){
            this.select_item.id = key
            this.select_item.name = (key==0)?"全部物资报废":"我发起的物资报废"
            this.getMaterialScrapApplyRecord()
        },
        async updateParam(newParam) {
                // 执行其他操作
                if(newParam.key == 1){ //更新审批信息
                    await this.getApprovalDetail()
                    this.getSchemeRecord()
                    let check = this.approvalDetail.find(it=>it.status != 1)
                    if(check == null){
                        this.selectRecord.status = 1
                    }
                }else if(newParam.key == 3){  //编辑申请
                    this.visibleCheckScrap = false;
                    this.visibleAddScrap = true;

                    this.scrapDetail.data = this.selectRecord.data
                    this.scrapDetail.data.flow_id = this.selectRecord.id

                    let ca = 1
                    this.defaultFileList = []
                    for(let item of this.selectRecord.data.attachment){
                        let as = {
                            uid: ca.toString(),
                            name: item.name,
                            status: 'done',
                            url: item.url,
                        }
                        this.defaultFileList.push(as)
                        ca++
                    }
                    this.selectRecord.flow_data = JSON.parse(this.selectRecord.flow_data) 
                    this.$nextTick(()=>{
                        this.flowdata = this.selectRecord.flow_data[0].persons.map((it)=>{return it + ""});
                    })
                
                }
            },
    },
};
</script>
<style scoped>
#components-form-demo-validate-other .dropbox {
    height: 180px;
    line-height: 1.5;
}
.editable-row-operations a {
    margin-right: 8px;
}

</style>